import React from 'react';

import * as Styled from './event.style';

export type EventTimeProps = {
  timeText: string;
  color?: string | null;
  completed?: boolean;
  past?: boolean;
};

// Renders the event time as "start - end", but keeps the end part in a separate
// element so the short-event row layout (see TextColumn / TimeEnd) can drop it
// and show just the start time, leaving the title the available space.
export const EventTime: React.FC<EventTimeProps> = ({
  timeText,
  color,
  completed,
  past,
}) => {
  const [start, ...rest] = timeText.split(' - ');
  const end = rest.join(' - ');

  return (
    <Styled.TimeText $color={color} $completed={completed} $past={past}>
      {start}
      {!!end && <Styled.TimeEnd>{` - ${end}`}</Styled.TimeEnd>}
    </Styled.TimeText>
  );
};
